import { UIIcon } from '../config/icons';
import { ABFilterBar } from '../lib/ab/filter-bar';
import { ABObjectCount } from '../lib/ab/widgets-admin';
import { l_access_keys, LAccessKey } from '../lib/mdl/l-access-key';
import { l_permission_specs, LPermission, lPermissionsDescription, LPermissionSpec } from '../lib/mdl/l-permission';
import { XJobGroup, XJob, xJobCreate, xJobsGetAll, x_job_group_values } from '../lib/mdl/x-job';
import { XLogEntry, xLogGet, xLogQuery } from '../lib/mdl/x-log';
import { XNetworkAccessGroup, XNetworkAccessEntry, xNetworkAccessCreate, xNetworkAccessGetAll, xNetworkAccessDelete } from '../lib/mdl/x-network-access';
import { XSecret, xSecretCreate, xSecretGet, xSecretsGetAll } from '../lib/mdl/x-secret';
import { the_login_token } from '../lib/me/login';
import { UIInputAdapter } from '../lib/ui/component/adapter';
import { UIButton, makeActionButton } from '../lib/ui/component/button';
import { UIDialog } from '../lib/ui/component/dialog';
import { UITextInput, UINumberInput } from '../lib/ui/component/input';
import { UILabeled } from '../lib/ui/component/labeled';
import { UIList } from '../lib/ui/component/list';
import { UISelect } from '../lib/ui/component/select';
import { UITableDefinition, UITable } from '../lib/ui/component/table';
import { uiToast } from '../lib/ui/component/toast';
import { UICheckbox } from '../lib/ui/component/toggle';
import { $el } from '../lib/ui/elements';
import { $fmt } from '../lib/ui/fmt';
import { UIScreen } from '../lib/ui/screen';
import { UIValue } from '../lib/ui/types';
import { UIViewSpec } from '../lib/ui/view';
import { YArrayDataSource } from '../lib/y/data-source';
import { $log, xavis_experiments } from '../lib/y/debug';
import { $on } from '../lib/y/events';
import { $form } from '../lib/y/form';
import { $http } from '../lib/y/http';
import { $i18n } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { $time } from '../lib/y/time';
import { YId, YFlags } from '../lib/y/types';

export class AdminLogScreen extends UIScreen {
    constructor(private _log_id: YId) {
        super();
    }

    protected override async fillContent(content: UIViewSpec) {
        const entry = await xLogGet(this._log_id);

        $log('app', 'entry', entry);
        if(entry.stack_trace) {
            $log('app', 'entry stack trace', entry.stack_trace);
            const lines = entry.stack_trace.split('\n');
            for(let i = 1; i < lines.length - 1; i += 2) {
                const fn = lines[i].trim();
                const loc = lines[i + 1].trim();
                let file = loc.split(' ')[0];
                const prefix = '/usr/local/abundo/go/';
                if(file.startsWith(prefix)) {
                    file = '/home/xavi/src/go/' + file.slice(prefix.length);
                }

                content.ui_add($el.P('text', $el.A('vscode-insiders://vscode-remote/wsl+Ubuntu' + file, fn)));
            }
        }

        content.ui_add
    }
}

export class AdminLogsScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const doSearch = () => {
            source.data = all_entries;
        }

        const doRefresh = async () => {
            // all_intents = await $tl.getAllPaymentIntents();
            doSearch();
        }

        const count = new ABObjectCount('entries');

        const filter_bar = new ABFilterBar({
            on_refresh: doRefresh,
            on_filter: doSearch,
            on_search: doSearch,
            right_content: [count],
            no_header: true
        });

        // const filters = filter_bar.filters;
        // filters.addCity();
        // if(xavis_experiments) {
        //     filters.addIsTest();
        //     filters.add('test_mode', 'Test mode', ['false'], 'No test');
        // }

        const def = new UITableDefinition<XLogEntry>();

        def.addCustom({
            width: -60, classes: 'tl-thumb-cell', decorator: (td, row) => {
                const kind = row.item.kind;
                td.append($el.DIV(['o-log-kind-icon', 'm-' + kind], kind.slice(0, 3)));
            }
        });
        def.addValue(l => $time(l.timestamp), $fmt.DATE('MM-dd HH:mm:ss'), { title: 'Date', width: -120 });
        def.addValue(l => l.status, $fmt.NUMBER, { title: 'Status', width: -90 });
        def.addValue(l => l.endpoint, { title: 'Path', width: 200 });
        def.addValue(l => l.t_total / 1000000000, $fmt.DURATION, { title: 'Elapsed', width: -120 });
        def.addValue(l => l.t_process / 1000000000, $fmt.DURATION, { title: 'Process', width: -120 });
        def.addButtons([
            {
                icon: UIIcon.EYE, tooltip: 'Open', action: l => {
                    $location.push({ transient: new AdminLogScreen(l.id) });
                }
            }
        ], { width: -30 });

        def.preference_prefix = 'system_logs';

        const response = await xLogQuery({ filter: { by: { kind: { not: { eq: { str: 'api' } } }, endpoint: { eq: { str: 'bookings.expirereserve' } } } } });
        let all_entries = response.data;
        $log('app', 'sql', response.query_sql);
        $log('app', 'query time', (response.t_query / 1000000).toFixed(0) + 'ms');

        const source = new YArrayDataSource<XLogEntry>();

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block m-wide', [
                filter_bar,
                new UITable(def, source),
            ]))
        ]);

        doSearch();
    }
}

class NewJobDialog extends UIDialog {
    constructor() {
        super({ classes: 'm-600 m-mobile-fs' });

        const group_values: UIValue<XJobGroup>[] = x_job_group_values.map(v => ({ key: v, name: v }));
        const group = new UISelect(group_values, { required: true });
        const code = new UITextInput({ required: true });
        const interval = new UINumberInput({ required: true, scale: 1000000000 });

        const form = $form({ group, code, interval });

        const buttons = $el.DIV('l-button-row m-right', [
            new UIButton({
                title: $i18n.tl.b_cancel, classes: 'm-hollow', on_click: () => {
                    this.dismiss(null);
                }
            }),
            new UIButton({
                title: "Create", classes: 'ui-tint-reverse', on_click: () => {
                    if(!form.validate()) return;
                    const value = form.value;
                    value.is_enabled = true;

                    return xJobCreate(value).then(() => {
                        this.dismiss(true);
                    }, uiToast);
                }
            })
        ]);

        this.content.ui_add($el.DIV('w-block l-form tl-producer-form m-compact', [
            new UILabeled(group, { above: 'Group' }),
            new UILabeled(code, { above: 'Code' }),
            new UILabeled(interval, { above: 'Interval (seconds)' }),
            buttons
        ]));
    }
}

export class AdminJobsScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const all_jobs = await xJobsGetAll();

        const doSearch = () => {
            count.number = all_jobs.length;
            source.data = all_jobs;
        }

        const def = new UITableDefinition<XJob>();
        def.addValue(l => $time(l.due_at), $fmt.DATE('MM-dd HH:mm:ss'), { title: 'Due', width: -120 });
        def.addValue(l => l.group, { title: 'Group', width: -120 });
        def.addValue(l => l.code, { title: 'Code', width: 200 });
        def.addValue(l => l.last_status?.toString() ?? '', { title: 'Status', width: -80 });
        def.addValue(l => l.is_enabled, $fmt.CHECKMARK, { title: 'Enabled', width: -100 });
        def.addValue(l => l.interval ? l.interval / 1000000000 : undefined, $fmt.DURATION, { title: 'Interval', width: -120 });
        def.addButtons([
            {
                icon: UIIcon.EYE, tooltip: 'Print', action: l => {
                    $log('app', '%O', l);
                }
            }
        ], { width: -30 });

        def.preference_prefix = 'x_jobs';

        const count = new ABObjectCount('jobs');
        const filter_bar = new ABFilterBar({
            right_content: [count],
            no_header: true
        })

        const source = new YArrayDataSource<XJob>;

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block', [
                filter_bar,
                new UITable(def, source),
            ])),
            makeActionButton(UIIcon.PLUS, 'New job', () => {
                new NewJobDialog().present().then($location.reload);
            })
        ]);

        doSearch();
    }
}

class AccessKeyScreen extends UIScreen {
    constructor(private _key?: LAccessKey) {
        super();
        this.title = _key?.name || 'New key';
    }

    protected override fillContent(content: UIViewSpec): void {
        const key = this._key;

        const name = new UITextInput({ required: true });
        const scope = new UITextInput({ required: true });

        const form = $form({ name, scope });

        let permissions: YFlags<LPermission>;

        if(key) {
            form.value = key;
            permissions = key.permissions;
        } else {
            permissions = {};
        }

        const def = new UITableDefinition<LPermissionSpec>();
        const checkboxDecorator = (td: HTMLTableCellElement, item: LPermissionSpec, kind: 'view' | 'manage') => {
            if(!item[kind]) return;
            const checkbox = new UICheckbox({ classes: 'u-inline' }); // TODO: we don't like u-inline, should remove
            const key = item.key + '.' + kind as LPermission
            checkbox.value = permissions[key];

            $on(checkbox, 'value', v => {
                if(v) {
                    if(!permissions[key])
                        permissions[key] = true;
                } else {
                    delete permissions[key];
                }
            })

            td.classList.add('m-no-padding');
            td.ui_add(checkbox);
        }

        def.addValue(p => p.name, { title: 'Permission', width: -180 });
        def.addCustom({ title: 'View', width: -100, classes: 'm-center', decorator: (td, row) => checkboxDecorator(td, row.item, 'view') });
        def.addCustom({ title: 'Manage', width: -100, classes: 'm-center', decorator: (td, row) => checkboxDecorator(td, row.item, 'manage') });

        const source = new YArrayDataSource<LPermissionSpec>();
        source.data = xavis_experiments ? l_permission_specs : l_permission_specs.filter(s => !s.experiment);

        const section = $el.FORM('ui-section w-form l-form', [
            new UILabeled(name, { above: 'Name' }),
            new UILabeled(scope, { above: 'Scope' }),
            new UILabeled(new UITable(def, source), { above: 'Permissions' })
        ]);

        content.ui_add([
            section,
            makeActionButton(UIIcon.THUMBS_UP, key ? 'Update' : 'Create', () => {
                if(!form.validate()) return;

                const value = form.value;
                value.permissions = permissions

                l_access_keys.upsert(key?.id, value).then(() => {
                    $location.pop();
                }, uiToast);
            })
        ]);
    }
}

export class AdminAccessKeysScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const all_keys = await l_access_keys.getAll();

        const doSearch = () => {
            let keys = filter_bar.search_input!.filterArray(all_keys, (p, w) => {
                if(p.name.toLowerCase().includes(w)) return true;
                if(p.scope.toLowerCase().includes(w)) return true;
                return false;
            });

            count.number = all_keys.length;
            source.data = keys;
        }

        const def = new UITableDefinition<LAccessKey>();
        def.addValue(p => p.id, { title: 'Id', width: -280 });
        def.addValue(p => p.name, { title: 'Name', width: 200 });
        def.addValue(p => p.scope, { title: 'Scope', width: -100 });
        def.addValue(p => lPermissionsDescription(p.permissions), { title: 'Permissions', width: 300 });

        def.addButtons([{
            icon: UIIcon.PENCIL, tooltip: 'Edit', action: item => {
                $location.push({ transient: new AccessKeyScreen(item) });
            }
        }], { width: -30 });

        def.preference_prefix = 'l_access_keys';

        const count = new ABObjectCount('keys');
        const filter_bar = new ABFilterBar({
            on_search: doSearch,
            right_content: [count],
            no_header: true
        })

        const source = new YArrayDataSource<LAccessKey>;

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block', [
                filter_bar,
                new UITable(def, source),
            ])),
            makeActionButton(UIIcon.PLUS, 'New key', () => { $location.push({ transient: new AccessKeyScreen }) })
        ]);

        doSearch();
        this.onViewDidReappear = doSearch;
    }
}

export class AdminAPIToolScreen extends UIScreen {
    protected override fillContent(content: UIViewSpec): void {
        const url = new UITextInput({ required: true });
        const token = new UITextInput();
        const key = new UITextInput();

        const section = $el.FORM('ui-section w-form l-form', [
            new UILabeled(url, { above: 'URL' }),
            new UILabeled(token, { above: 'Token' }),
            new UILabeled(key, { above: 'Key' })
        ]);

        token.value = the_login_token!;

        content.ui_add([
            section,
            makeActionButton(UIIcon.THUMBS_UP, 'Go!', () => {
                if(!$form.validate(url)) return;

                const headers: { [key: string]: string } = {};
                if(token.value)
                    headers['X-Abundo-Token'] = token.value;
                else if(key.value)
                    headers['X-Abundo-Key'] = key.value;

                $http.GET(url.value, { no_global_headers: true, headers: headers }).then(r => {
                    $log('app', 'response', r);
                }, e => {
                    $log('app', 'error', e);
                })
            })
        ]);
    }
}

class NewNetworkAccessDialog extends UIDialog {
    constructor(user_ip: string) {
        super({ classes: 'm-600 m-mobile-fs' });

        const group_values: UIValue<XNetworkAccessGroup>[] = [
            { key: 'aurora', name: 'Aurora' },
            { key: 'backend', name: 'Backend' },
        ];
        const group = new UISelect(group_values, { required: true });
        const ip = new UITextInput({ required: true });
        const port = new UINumberInput({ required: true });
        const protocol = new UITextInput({ required: true });
        const description = new UITextInput({ required: true });
        const form = $form({ group, ip, port, protocol, description });

        ip.value = user_ip;

        $on(group, 'value', v => {
            if(v == 'aurora') {
                port.value = 5432;
                protocol.value = 'tcp';
            } else if(v == 'backend') {
                port.value = 22;
                protocol.value = 'tcp';
            }
        });

        const buttons = $el.DIV('l-button-row m-right', [
            new UIButton({
                title: $i18n.tl.b_cancel, classes: 'm-hollow', on_click: () => {
                    this.dismiss(null);
                }
            }),
            new UIButton({
                title: "Create", classes: 'ui-tint-reverse', on_click: () => {
                    if(!form.validate()) return;

                    return xNetworkAccessCreate(form.value).then(() => {
                        this.dismiss(true);
                    }, uiToast);
                }
            })
        ]);

        this.content.ui_add($el.DIV('w-block l-form tl-producer-form m-compact', [
            new UILabeled(group, { above: 'Group' }),
            new UILabeled(ip, { above: 'IP' }),
            new UILabeled(port, { above: 'Port' }),
            new UILabeled(protocol, { above: 'Protocol' }),
            new UILabeled(description, { above: 'Description' }),
            buttons
        ]));
    }
}

export class AdminNetworkAccessScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        const response = await xNetworkAccessGetAll();
        const all_entries = response.entries;

        const doSearch = () => {
            count.number = all_entries.length;
            source.data = all_entries;
        }

        const def = new UITableDefinition<XNetworkAccessEntry>();
        def.addValue(p => p.group, { title: 'Group', width: -200 });
        def.addValue(p => p.description, { title: 'Description', width: 200 });
        def.addValue(p => {
            if(p.ip_block.endsWith('/32')) {
                const ip = p.ip_block.slice(0, -3);
                if(ip == response.your_ip)
                    return ip + ' (your IP)';
                return ip;
            }
            return p.ip_block;
        }, { title: 'IP block', width: -240 });
        def.addValue(p => {
            if(p.port_from == p.port_to)
                return '' + p.port_from;
            return p.port_from + '-' + p.port_to;
        }, { title: 'Port', width: -160 });
        def.addValue(p => p.protocol, { title: 'Protocol', width: -100 });

        def.addButtons([{
            icon: UIIcon.TRASH_CAN, tooltip: 'Remove', action: item => {
                xNetworkAccessDelete(item.group, item.id).then(() => {
                    $location.reload();
                }, uiToast);
            }
        }], { width: -30 });

        def.preference_prefix = 'x_network_access';

        const count = new ABObjectCount('entries');
        const filter_bar = new ABFilterBar({
            right_content: [count],
            no_header: true
        })

        const source = new YArrayDataSource<XNetworkAccessEntry>;

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block', [
                filter_bar,
                new UITable(def, source),
            ])),
            makeActionButton(UIIcon.PLUS, 'New entry', () => {
                new NewNetworkAccessDialog(response.your_ip).present().then(() => {
                    $location.reload();
                });
            })
        ]);

        doSearch();
        this.onViewDidReappear = doSearch;
    }
}

class SecretScreen extends UIScreen {
    constructor(private _secret_name?: string) {
        super();
        this.title = _secret_name || 'New secret';
    }

    protected override async fillContent(content: UIViewSpec) {
        const secret_name = this._secret_name;

        const name = new UITextInput({ required: true, disabled: !!secret_name });
        const entries = new UIInputAdapter((_s: { entry: [string, string] }, entry) => {
            const container = $el.DIV('l-input-row m-top');
            const key = new UITextInput({ required: true });
            const value = new UITextInput({ required: true, lines: 3 });
            const remove = new UIButton({ icon: UIIcon.TRASH_CAN, on_click: () => { entries.remove(entry) } });
            container.ui_add([
                new UILabeled(key, { above: 'Key' }),
                new UILabeled(value, { above: 'Value' }),
                remove
            ]);

            return {
                view: container,
                input: $form({ entry: [key, value] })
            };
        })

        const form = $form({ name, entries });

        let permissions: LPermission[];

        if(secret_name) {
            name.value = secret_name;
            entries.value = Object.entries((await xSecretGet(secret_name)).secret).map(e => ({ entry: e }));
        }

        const def = new UITableDefinition<LPermissionSpec>();
        const checkboxDecorator = (td: HTMLTableCellElement, item: LPermissionSpec, kind: 'view' | 'manage') => {
            if(!item[kind]) return;
            const checkbox = new UICheckbox({ classes: 'u-inline' }); // TODO: we don't like u-inline, should remove
            const key = item.key + '.' + kind as LPermission
            checkbox.value = permissions.includes(key);

            $on(checkbox, 'value', v => {
                if(v) {
                    if(!permissions.includes(key))
                        permissions.push(key);
                } else {
                    permissions = permissions.filter(p => p != key);
                }
            })

            td.classList.add('m-no-padding');
            td.ui_add(checkbox);
        }

        def.addValue(p => p.name, { title: 'Permission', width: -180 });
        def.addCustom({ title: 'View', width: -100, classes: 'm-center', decorator: (td, row) => checkboxDecorator(td, row.item, 'view') });
        def.addCustom({ title: 'Manage', width: -100, classes: 'm-center', decorator: (td, row) => checkboxDecorator(td, row.item, 'manage') });

        const source = new YArrayDataSource<LPermissionSpec>();
        source.data = xavis_experiments ? l_permission_specs : l_permission_specs.filter(s => !s.experiment);

        const section = $el.FORM('ui-section w-form l-form', [
            new UILabeled(name, { above: 'Name' }),
            new UIList(entries, { classes: 'l-form' }),
            new UIButton({ title: '+ Add entry', kind: 'k-text', on_click: () => { entries.push({} as any, true) } })
        ]);

        content.ui_add([
            section,
            makeActionButton(UIIcon.THUMBS_UP, secret_name ? 'Update' : 'Create', () => {
                if(!form.validate()) return;

                xSecretCreate(name.value, Object.fromEntries(entries.value.map(e => e.entry))).then(() => {
                    $location.pop();
                }, uiToast);
            })
        ]);
    }
}

export class AdminSecretsScreen extends UIScreen {
    protected override async fillContent(content: UIViewSpec) {
        let all_secrets = await xSecretsGetAll();

        const doSearch = () => {
            count.number = all_secrets.length;
            source.data = all_secrets;
        }

        const def = new UITableDefinition<XSecret>();
        def.addValue(s => s.name, { title: 'Group', width: -200 });
        def.addValue(s => s.key_version, $fmt.NUMBER, { title: 'Key version', width: -120 });
        def.addValue(s => Object.keys(s.secret).join(', '), { title: 'Values', width: 200 });

        def.addButtons([{
            icon: UIIcon.TRASH_CAN, tooltip: 'Remove', action: _item => {
                // $tl.removeSec(item.group, item.id).then(() => {
                //     $location.reload();
                // }, uiToast);
            }
        }, {
            icon: UIIcon.PENCIL, tooltip: 'Edit', action: item => {
                $location.push({ transient: new SecretScreen(item.name) });
            }
        }], { width: -62 });

        def.preference_prefix = 'secrets';

        const count = new ABObjectCount('secrets');
        const filter_bar = new ABFilterBar({
            right_content: [count],
            no_header: true
        })

        const source = new YArrayDataSource<XSecret>;

        content.ui_add([
            $el.SECTION('pad-t-narrow', $el.DIV('tl-new-list-block', [
                filter_bar,
                new UITable(def, source),
            ])),
            makeActionButton(UIIcon.PLUS, 'New secret', () => { $location.push({ transient: new SecretScreen }) })
        ]);

        doSearch();
        this.onViewDidReappear = () => {
            xSecretsGetAll().then(s => {
                all_secrets = s;
                doSearch();
            });
        };
    }
}
